import Vue from 'vue'
import Vuex from 'vuex'
import objectAssign from 'object-assign'
Vue.use(Vuex)
//页面切换loading
const store = new Vuex.Store({
  state: {
    newData: {}
  },
  mutations: {
    updateNewData(state, data) {
      state.newData = objectAssign({}, state.newData, data)
    }
  }
})
store.registerModule('vux', {
  state: {
    isLoading: false,
    loaddingText: '加载中'
  },
  mutations: {
    updateLoadingStatus(state, payload) {
      state.isLoading = payload.isLoading
    },
    updateLoaddingText(state, text) {
      state.loaddingText = text
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js